// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file billing/v1/billing.proto (package billing.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file billing/v1/billing.proto.
 */
export const file_billing_v1_billing: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_google_protobuf_timestamp],
	);

/**
 * Account is the container for a billing account
 *
 * @generated from message billing.v1.Account
 */
export type Account = Message<"billing.v1.Account"> & {
	/**
	 * The name of the account
	 *
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * The description of the account
	 *
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * The external provider account ID
	 *
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId: string;

	/**
	 * The external provider account number
	 *
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber: string;

	/**
	 * The default payment method ID
	 *
	 * @generated from field: string default_payment_method_id = 5;
	 */
	defaultPaymentMethodId: string;

	/**
	 * Contracted monthly recurring revenue for the accounts subscription.
	 *
	 * @generated from field: double contracted_mrr = 6;
	 */
	contractedMrr: number;

	/**
	 * Account status
	 *
	 * @generated from field: billing.v1.AccountStatus status = 7;
	 */
	status: AccountStatus;

	/**
	 * The contact information for the accounts bill-to contact
	 *
	 * @generated from field: billing.v1.Contact bill_to_contact = 8;
	 */
	billToContact?: Contact;

	/**
	 * The contact information for the accounts sold-to contact
	 *
	 * @generated from field: billing.v1.Contact sold_to_contact = 9;
	 */
	soldToContact?: Contact;

	/**
	 * The timestamp the account was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp;

	/**
	 * The timestamp the account was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp;

	/**
	 * The sales pod the account is associated with
	 *
	 * @generated from field: string pod = 12;
	 */
	pod: string;

	/**
	 * The sales channel the account is associated with
	 *
	 * @generated from field: string sales_channel = 13;
	 */
	salesChannel: string;

	/**
	 * The vertical the account is associated with
	 *
	 * @generated from field: string vertical = 14;
	 */
	vertical: string;

	/**
	 * The customer success manager the account is associated with
	 *
	 * @generated from field: string csm = 15;
	 */
	csm: string;
};

/**
 * Account is the container for a billing account
 *
 * @generated from message billing.v1.Account
 */
export type AccountJson = {
	/**
	 * The name of the account
	 *
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * The description of the account
	 *
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * The external provider account ID
	 *
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId?: string;

	/**
	 * The external provider account number
	 *
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber?: string;

	/**
	 * The default payment method ID
	 *
	 * @generated from field: string default_payment_method_id = 5;
	 */
	defaultPaymentMethodId?: string;

	/**
	 * Contracted monthly recurring revenue for the accounts subscription.
	 *
	 * @generated from field: double contracted_mrr = 6;
	 */
	contractedMrr?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * Account status
	 *
	 * @generated from field: billing.v1.AccountStatus status = 7;
	 */
	status?: AccountStatusJson;

	/**
	 * The contact information for the accounts bill-to contact
	 *
	 * @generated from field: billing.v1.Contact bill_to_contact = 8;
	 */
	billToContact?: ContactJson;

	/**
	 * The contact information for the accounts sold-to contact
	 *
	 * @generated from field: billing.v1.Contact sold_to_contact = 9;
	 */
	soldToContact?: ContactJson;

	/**
	 * The timestamp the account was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * The timestamp the account was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;

	/**
	 * The sales pod the account is associated with
	 *
	 * @generated from field: string pod = 12;
	 */
	pod?: string;

	/**
	 * The sales channel the account is associated with
	 *
	 * @generated from field: string sales_channel = 13;
	 */
	salesChannel?: string;

	/**
	 * The vertical the account is associated with
	 *
	 * @generated from field: string vertical = 14;
	 */
	vertical?: string;

	/**
	 * The customer success manager the account is associated with
	 *
	 * @generated from field: string csm = 15;
	 */
	csm?: string;
};

/**
 * Describes the message billing.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account, { jsonType: AccountJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 0);

/**
 * Contact is the container for a contact
 *
 * @generated from message billing.v1.Contact
 */
export type Contact = Message<"billing.v1.Contact"> & {
	/**
	 * The first name of the contact
	 *
	 * @generated from field: string first_name = 1;
	 */
	firstName: string;

	/**
	 * The last name of the contact
	 *
	 * @generated from field: string last_name = 2;
	 */
	lastName: string;

	/**
	 * The address line 1 of the contact
	 *
	 * @generated from field: string address1 = 3;
	 */
	address1: string;

	/**
	 * The address line 2 of the contact
	 *
	 * @generated from field: string address2 = 4;
	 */
	address2: string;

	/**
	 * The city of the contact
	 *
	 * @generated from field: string city = 5;
	 */
	city: string;

	/**
	 * The state of the contact
	 *
	 * @generated from field: string state = 6;
	 */
	state: string;

	/**
	 * The postal code of the contact
	 *
	 * @generated from field: string postal_code = 7;
	 */
	postalCode: string;

	/**
	 * The country of the contact
	 *
	 * @generated from field: string country = 8;
	 */
	country: string;

	/**
	 * The mobile phone number of the contact
	 *
	 * @generated from field: string mobile_phone = 9;
	 */
	mobilePhone: string;

	/**
	 * The personal email address of the contact
	 *
	 * @generated from field: string personal_email = 10;
	 */
	personalEmail: string;

	/**
	 * The work email address of the contact
	 *
	 * @generated from field: string work_email = 11;
	 */
	workEmail: string;

	/**
	 * The work phone number of the contact
	 *
	 * @generated from field: string work_phone = 12;
	 */
	workPhone: string;

	/**
	 * The external provider contact ID
	 *
	 * @generated from field: string provider_contact_id = 13;
	 */
	providerContactId: string;

	/**
	 * The timestamp the contact was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: Timestamp;

	/**
	 * The timestamp the contact was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: Timestamp;
};

/**
 * Contact is the container for a contact
 *
 * @generated from message billing.v1.Contact
 */
export type ContactJson = {
	/**
	 * The first name of the contact
	 *
	 * @generated from field: string first_name = 1;
	 */
	firstName?: string;

	/**
	 * The last name of the contact
	 *
	 * @generated from field: string last_name = 2;
	 */
	lastName?: string;

	/**
	 * The address line 1 of the contact
	 *
	 * @generated from field: string address1 = 3;
	 */
	address1?: string;

	/**
	 * The address line 2 of the contact
	 *
	 * @generated from field: string address2 = 4;
	 */
	address2?: string;

	/**
	 * The city of the contact
	 *
	 * @generated from field: string city = 5;
	 */
	city?: string;

	/**
	 * The state of the contact
	 *
	 * @generated from field: string state = 6;
	 */
	state?: string;

	/**
	 * The postal code of the contact
	 *
	 * @generated from field: string postal_code = 7;
	 */
	postalCode?: string;

	/**
	 * The country of the contact
	 *
	 * @generated from field: string country = 8;
	 */
	country?: string;

	/**
	 * The mobile phone number of the contact
	 *
	 * @generated from field: string mobile_phone = 9;
	 */
	mobilePhone?: string;

	/**
	 * The personal email address of the contact
	 *
	 * @generated from field: string personal_email = 10;
	 */
	personalEmail?: string;

	/**
	 * The work email address of the contact
	 *
	 * @generated from field: string work_email = 11;
	 */
	workEmail?: string;

	/**
	 * The work phone number of the contact
	 *
	 * @generated from field: string work_phone = 12;
	 */
	workPhone?: string;

	/**
	 * The external provider contact ID
	 *
	 * @generated from field: string provider_contact_id = 13;
	 */
	providerContactId?: string;

	/**
	 * The timestamp the contact was created
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: TimestampJson;

	/**
	 * The timestamp the contact was last updated
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message billing.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact, { jsonType: ContactJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 1);

/**
 * Subscription is the container for a subscription
 *
 * @generated from message billing.v1.Subscription
 */
export type Subscription = Message<"billing.v1.Subscription"> & {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: string prodiver_subscription_id = 2 [deprecated = true];
	 * @deprecated
	 */
	prodiverSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_id = 25;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus status = 4;
	 */
	status: SubscriptionStatus;

	/**
	 * @generated from field: double contracted_mrr = 5;
	 */
	contractedMrr: number;

	/**
	 * @generated from field: repeated billing.v1.RatePlan rate_plans = 6;
	 */
	ratePlans: RatePlan[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp subscription_start_date = 9;
	 */
	subscriptionStartDate?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp subscription_end_date = 10;
	 */
	subscriptionEndDate?: Timestamp;

	/**
	 * @generated from field: double total_contracted_value = 11;
	 */
	totalContractedValue: number;

	/**
	 * @generated from field: string account_name = 12;
	 */
	accountName: string;

	/**
	 * @generated from field: bool auto_renew = 13;
	 */
	autoRenew: boolean;

	/**
	 * @generated from field: string provider_account_number = 14;
	 */
	providerAccountNumber: string;

	/**
	 * @generated from field: string invoice_owner_provider_account_id = 15;
	 */
	invoiceOwnerProviderAccountId: string;

	/**
	 * @generated from field: string invoice_owner_provider_account_number = 16;
	 */
	invoiceOwnerProviderAccountNumber: string;

	/**
	 * @generated from field: string invoice_owner_account_name = 17;
	 */
	invoiceOwnerAccountName: string;

	/**
	 * @generated from field: billing.v1.Contact bill_to_contact = 18;
	 */
	billToContact?: Contact;

	/**
	 * @generated from field: bool is_latest_version = 19;
	 */
	isLatestVersion: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp term_start = 20;
	 */
	termStart?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp term_end = 21;
	 */
	termEnd?: Timestamp;

	/**
	 * @generated from field: billing.v1.TermType term_type = 22;
	 */
	termType: TermType;

	/**
	 * @generated from field: int32 version = 23;
	 */
	version: number;

	/**
	 * @generated from field: string provider_previous_subscription_id = 24;
	 */
	providerPreviousSubscriptionId: string;

	/**
	 * @generated from field: bool is_in_term = 26;
	 */
	isInTerm: boolean;
};

/**
 * Subscription is the container for a subscription
 *
 * @generated from message billing.v1.Subscription
 */
export type SubscriptionJson = {
	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: string prodiver_subscription_id = 2 [deprecated = true];
	 * @deprecated
	 */
	prodiverSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_id = 25;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 3;
	 */
	providerSubscriptionNumber?: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus status = 4;
	 */
	status?: SubscriptionStatusJson;

	/**
	 * @generated from field: double contracted_mrr = 5;
	 */
	contractedMrr?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: repeated billing.v1.RatePlan rate_plans = 6;
	 */
	ratePlans?: RatePlanJson[];

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp subscription_start_date = 9;
	 */
	subscriptionStartDate?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp subscription_end_date = 10;
	 */
	subscriptionEndDate?: TimestampJson;

	/**
	 * @generated from field: double total_contracted_value = 11;
	 */
	totalContractedValue?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string account_name = 12;
	 */
	accountName?: string;

	/**
	 * @generated from field: bool auto_renew = 13;
	 */
	autoRenew?: boolean;

	/**
	 * @generated from field: string provider_account_number = 14;
	 */
	providerAccountNumber?: string;

	/**
	 * @generated from field: string invoice_owner_provider_account_id = 15;
	 */
	invoiceOwnerProviderAccountId?: string;

	/**
	 * @generated from field: string invoice_owner_provider_account_number = 16;
	 */
	invoiceOwnerProviderAccountNumber?: string;

	/**
	 * @generated from field: string invoice_owner_account_name = 17;
	 */
	invoiceOwnerAccountName?: string;

	/**
	 * @generated from field: billing.v1.Contact bill_to_contact = 18;
	 */
	billToContact?: ContactJson;

	/**
	 * @generated from field: bool is_latest_version = 19;
	 */
	isLatestVersion?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp term_start = 20;
	 */
	termStart?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp term_end = 21;
	 */
	termEnd?: TimestampJson;

	/**
	 * @generated from field: billing.v1.TermType term_type = 22;
	 */
	termType?: TermTypeJson;

	/**
	 * @generated from field: int32 version = 23;
	 */
	version?: number;

	/**
	 * @generated from field: string provider_previous_subscription_id = 24;
	 */
	providerPreviousSubscriptionId?: string;

	/**
	 * @generated from field: bool is_in_term = 26;
	 */
	isInTerm?: boolean;
};

/**
 * Describes the message billing.v1.Subscription.
 * Use `create(SubscriptionSchema)` to create a new message.
 */
export const SubscriptionSchema: GenMessage<Subscription, { jsonType: SubscriptionJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 2);

/**
 * @generated from message billing.v1.RatePlan
 */
export type RatePlan = Message<"billing.v1.RatePlan"> & {
	/**
	 * @generated from field: string product_name = 3;
	 */
	productName: string;

	/**
	 * @generated from field: string product_rate_plan_name = 4;
	 */
	productRatePlanName: string;

	/**
	 * @generated from field: string provider_product_id = 5;
	 */
	providerProductId: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 6;
	 */
	providerProductRatePlanId: string;

	/**
	 * @generated from field: string provider_rate_plan_id = 7;
	 */
	providerRatePlanId: string;

	/**
	 * @generated from field: repeated billing.v1.RatePlanCharge rate_plan_charges = 8;
	 */
	ratePlanCharges: RatePlanCharge[];

	/**
	 * @generated from field: bool is_active = 9;
	 */
	isActive: boolean;
};

/**
 * @generated from message billing.v1.RatePlan
 */
export type RatePlanJson = {
	/**
	 * @generated from field: string product_name = 3;
	 */
	productName?: string;

	/**
	 * @generated from field: string product_rate_plan_name = 4;
	 */
	productRatePlanName?: string;

	/**
	 * @generated from field: string provider_product_id = 5;
	 */
	providerProductId?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 6;
	 */
	providerProductRatePlanId?: string;

	/**
	 * @generated from field: string provider_rate_plan_id = 7;
	 */
	providerRatePlanId?: string;

	/**
	 * @generated from field: repeated billing.v1.RatePlanCharge rate_plan_charges = 8;
	 */
	ratePlanCharges?: RatePlanChargeJson[];

	/**
	 * @generated from field: bool is_active = 9;
	 */
	isActive?: boolean;
};

/**
 * Describes the message billing.v1.RatePlan.
 * Use `create(RatePlanSchema)` to create a new message.
 */
export const RatePlanSchema: GenMessage<RatePlan, { jsonType: RatePlanJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 3);

/**
 * @generated from message billing.v1.RatePlanCharge
 */
export type RatePlanCharge = Message<"billing.v1.RatePlanCharge"> & {
	/**
	 * @generated from field: string provider_rate_plan_charge_id = 3;
	 */
	providerRatePlanChargeId: string;

	/**
	 * @generated from field: string provider_rate_plan_charge_number = 4;
	 */
	providerRatePlanChargeNumber: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_id = 5;
	 */
	providerProductRatePlanChargeId: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_number = 6;
	 */
	providerProductRatePlanChargeNumber: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name: string;

	/**
	 * @generated from field: billing.v1.ChargeType charge_type = 8;
	 */
	chargeType: ChargeType;

	/**
	 * @generated from field: billing.v1.ChargeModel charge_model = 9;
	 */
	chargeModel: ChargeModel;

	/**
	 * @generated from field: string uom = 10;
	 */
	uom: string;

	/**
	 * @generated from field: double quantity = 11;
	 */
	quantity: number;

	/**
	 * @generated from field: double mrr = 12;
	 */
	mrr: number;

	/**
	 * @generated from field: repeated billing.v1.ChargeTier tiers = 13;
	 */
	tiers: ChargeTier[];

	/**
	 * @generated from field: double price = 14;
	 */
	price: number;

	/**
	 * @generated from field: double sales_price = 15;
	 */
	salesPrice: number;

	/**
	 * @generated from field: string pricing_summary = 16;
	 */
	pricingSummary: string;

	/**
	 * @generated from field: double discount_amount = 17;
	 */
	discountAmount: number;

	/**
	 * @generated from field: double discount_percentage = 18;
	 */
	discountPercentage: number;

	/**
	 * @generated from field: double included_units = 19;
	 */
	includedUnits: number;

	/**
	 * @generated from field: string billing_period = 20;
	 */
	billingPeriod: string;

	/**
	 * @generated from field: double overage_price = 21;
	 */
	overagePrice: number;

	/**
	 * @generated from field: google.protobuf.Timestamp effective_start_date = 22;
	 */
	effectiveStartDate?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp effective_end_date = 23;
	 */
	effectiveEndDate?: Timestamp;

	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 24;
	 */
	featureType: FeatureType;

	/**
	 * @generated from field: bool is_current_segment = 25;
	 */
	isCurrentSegment: boolean;
};

/**
 * @generated from message billing.v1.RatePlanCharge
 */
export type RatePlanChargeJson = {
	/**
	 * @generated from field: string provider_rate_plan_charge_id = 3;
	 */
	providerRatePlanChargeId?: string;

	/**
	 * @generated from field: string provider_rate_plan_charge_number = 4;
	 */
	providerRatePlanChargeNumber?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_id = 5;
	 */
	providerProductRatePlanChargeId?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_number = 6;
	 */
	providerProductRatePlanChargeNumber?: string;

	/**
	 * @generated from field: string name = 7;
	 */
	name?: string;

	/**
	 * @generated from field: billing.v1.ChargeType charge_type = 8;
	 */
	chargeType?: ChargeTypeJson;

	/**
	 * @generated from field: billing.v1.ChargeModel charge_model = 9;
	 */
	chargeModel?: ChargeModelJson;

	/**
	 * @generated from field: string uom = 10;
	 */
	uom?: string;

	/**
	 * @generated from field: double quantity = 11;
	 */
	quantity?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double mrr = 12;
	 */
	mrr?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: repeated billing.v1.ChargeTier tiers = 13;
	 */
	tiers?: ChargeTierJson[];

	/**
	 * @generated from field: double price = 14;
	 */
	price?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double sales_price = 15;
	 */
	salesPrice?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string pricing_summary = 16;
	 */
	pricingSummary?: string;

	/**
	 * @generated from field: double discount_amount = 17;
	 */
	discountAmount?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double discount_percentage = 18;
	 */
	discountPercentage?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: double included_units = 19;
	 */
	includedUnits?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string billing_period = 20;
	 */
	billingPeriod?: string;

	/**
	 * @generated from field: double overage_price = 21;
	 */
	overagePrice?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: google.protobuf.Timestamp effective_start_date = 22;
	 */
	effectiveStartDate?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp effective_end_date = 23;
	 */
	effectiveEndDate?: TimestampJson;

	/**
	 * @generated from field: billing.v1.FeatureType feature_type = 24;
	 */
	featureType?: FeatureTypeJson;

	/**
	 * @generated from field: bool is_current_segment = 25;
	 */
	isCurrentSegment?: boolean;
};

/**
 * Describes the message billing.v1.RatePlanCharge.
 * Use `create(RatePlanChargeSchema)` to create a new message.
 */
export const RatePlanChargeSchema: GenMessage<RatePlanCharge, { jsonType: RatePlanChargeJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 4);

/**
 * @generated from message billing.v1.ChargeTier
 */
export type ChargeTier = Message<"billing.v1.ChargeTier"> & {
	/**
	 * @generated from field: int64 tier = 1;
	 */
	tier: bigint;

	/**
	 * @generated from field: double price = 2;
	 */
	price: number;

	/**
	 * @generated from field: string price_format = 3;
	 */
	priceFormat: string;

	/**
	 * @generated from field: int64 starting_unit = 4;
	 */
	startingUnit: bigint;

	/**
	 * @generated from field: int64 ending_unit = 5;
	 */
	endingUnit: bigint;
};

/**
 * @generated from message billing.v1.ChargeTier
 */
export type ChargeTierJson = {
	/**
	 * @generated from field: int64 tier = 1;
	 */
	tier?: string;

	/**
	 * @generated from field: double price = 2;
	 */
	price?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string price_format = 3;
	 */
	priceFormat?: string;

	/**
	 * @generated from field: int64 starting_unit = 4;
	 */
	startingUnit?: string;

	/**
	 * @generated from field: int64 ending_unit = 5;
	 */
	endingUnit?: string;
};

/**
 * Describes the message billing.v1.ChargeTier.
 * Use `create(ChargeTierSchema)` to create a new message.
 */
export const ChargeTierSchema: GenMessage<ChargeTier, { jsonType: ChargeTierJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 5);

/**
 * ProductRatePlanCharge is the container for the charge template that is used to create a subscription rate plan charge
 *
 * @generated from message billing.v1.ProductRatePlanCharge
 */
export type ProductRatePlanCharge = Message<"billing.v1.ProductRatePlanCharge"> & {
	/**
	 * @generated from field: string provider_product_rate_plan_charge_id = 1;
	 */
	providerProductRatePlanChargeId: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_number = 2;
	 */
	providerProductRatePlanChargeNumber: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 3;
	 */
	providerProductRatePlanId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: billing.v1.ChargeType charge_type = 5;
	 */
	chargeType: ChargeType;

	/**
	 * @generated from field: billing.v1.ChargeModel charge_model = 6;
	 */
	chargeModel: ChargeModel;

	/**
	 * @generated from field: string uom = 7;
	 */
	uom: string;

	/**
	 * // The key/slug of the feature that the charge is associated with
	 * string feature_key = 9;
	 * // The type of entitlement that should be used to grant access of the associated feature
	 * string entitlement_type = 10;
	 * // Whether the feature should be measured in terms of usage or capacity
	 * bool is_soft_limit = 11;
	 *
	 * @generated from field: double default_quantity = 8;
	 */
	defaultQuantity: number;
};

/**
 * ProductRatePlanCharge is the container for the charge template that is used to create a subscription rate plan charge
 *
 * @generated from message billing.v1.ProductRatePlanCharge
 */
export type ProductRatePlanChargeJson = {
	/**
	 * @generated from field: string provider_product_rate_plan_charge_id = 1;
	 */
	providerProductRatePlanChargeId?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_charge_number = 2;
	 */
	providerProductRatePlanChargeNumber?: string;

	/**
	 * @generated from field: string provider_product_rate_plan_id = 3;
	 */
	providerProductRatePlanId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: billing.v1.ChargeType charge_type = 5;
	 */
	chargeType?: ChargeTypeJson;

	/**
	 * @generated from field: billing.v1.ChargeModel charge_model = 6;
	 */
	chargeModel?: ChargeModelJson;

	/**
	 * @generated from field: string uom = 7;
	 */
	uom?: string;

	/**
	 * // The key/slug of the feature that the charge is associated with
	 * string feature_key = 9;
	 * // The type of entitlement that should be used to grant access of the associated feature
	 * string entitlement_type = 10;
	 * // Whether the feature should be measured in terms of usage or capacity
	 * bool is_soft_limit = 11;
	 *
	 * @generated from field: double default_quantity = 8;
	 */
	defaultQuantity?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message billing.v1.ProductRatePlanCharge.
 * Use `create(ProductRatePlanChargeSchema)` to create a new message.
 */
export const ProductRatePlanChargeSchema: GenMessage<ProductRatePlanCharge, { jsonType: ProductRatePlanChargeJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 6);

/**
 * @generated from message billing.v1.UsageRecord
 */
export type UsageRecord = Message<"billing.v1.UsageRecord"> & {
	/**
	 * @generated from field: string provider_usage_record_id = 12;
	 */
	providerUsageRecordId: string;

	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: string provider_account_number = 2;
	 */
	providerAccountNumber: string;

	/**
	 * @generated from field: string provider_charge_id = 3;
	 */
	providerChargeId: string;

	/**
	 * @generated from field: string provider_charge_number = 4;
	 */
	providerChargeNumber: string;

	/**
	 * @generated from field: double quantity = 5;
	 */
	quantity: number;

	/**
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * @generated from field: string provider_subscription_id = 7;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 8;
	 */
	providerSubscriptionNumber: string;

	/**
	 * @generated from field: string uom = 9;
	 */
	uom: string;

	/**
	 * @generated from field: google.protobuf.Timestamp start_date_time = 10;
	 */
	startDateTime?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date_time = 11;
	 */
	endDateTime?: Timestamp;

	/**
	 * @generated from field: string status = 13;
	 */
	status: string;

	/**
	 * @generated from field: string source_type = 14;
	 */
	sourceType: string;

	/**
	 * @generated from field: string file_name = 15;
	 */
	fileName: string;

	/**
	 * @generated from field: google.protobuf.Timestamp submission_date_time = 16;
	 */
	submissionDateTime?: Timestamp;

	/**
	 * @generated from field: billing.v1.UsageRecordStatus usage_record_status = 17;
	 */
	usageRecordStatus: UsageRecordStatus;
};

/**
 * @generated from message billing.v1.UsageRecord
 */
export type UsageRecordJson = {
	/**
	 * @generated from field: string provider_usage_record_id = 12;
	 */
	providerUsageRecordId?: string;

	/**
	 * @generated from field: string provider_account_id = 1;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: string provider_account_number = 2;
	 */
	providerAccountNumber?: string;

	/**
	 * @generated from field: string provider_charge_id = 3;
	 */
	providerChargeId?: string;

	/**
	 * @generated from field: string provider_charge_number = 4;
	 */
	providerChargeNumber?: string;

	/**
	 * @generated from field: double quantity = 5;
	 */
	quantity?: number | "NaN" | "Infinity" | "-Infinity";

	/**
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * @generated from field: string provider_subscription_id = 7;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 8;
	 */
	providerSubscriptionNumber?: string;

	/**
	 * @generated from field: string uom = 9;
	 */
	uom?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp start_date_time = 10;
	 */
	startDateTime?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date_time = 11;
	 */
	endDateTime?: TimestampJson;

	/**
	 * @generated from field: string status = 13;
	 */
	status?: string;

	/**
	 * @generated from field: string source_type = 14;
	 */
	sourceType?: string;

	/**
	 * @generated from field: string file_name = 15;
	 */
	fileName?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp submission_date_time = 16;
	 */
	submissionDateTime?: TimestampJson;

	/**
	 * @generated from field: billing.v1.UsageRecordStatus usage_record_status = 17;
	 */
	usageRecordStatus?: UsageRecordStatusJson;
};

/**
 * Describes the message billing.v1.UsageRecord.
 * Use `create(UsageRecordSchema)` to create a new message.
 */
export const UsageRecordSchema: GenMessage<UsageRecord, { jsonType: UsageRecordJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 7);

/**
 * @generated from message billing.v1.EntityAccount
 */
export type EntityAccount = Message<"billing.v1.EntityAccount"> & {
	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 1;
	 */
	entityType: EntityAccountType;

	/**
	 * @generated from field: string entity_id = 2;
	 */
	entityId: string;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber: string;
};

/**
 * @generated from message billing.v1.EntityAccount
 */
export type EntityAccountJson = {
	/**
	 * @generated from field: billing.v1.EntityAccountType entity_type = 1;
	 */
	entityType?: EntityAccountTypeJson;

	/**
	 * @generated from field: string entity_id = 2;
	 */
	entityId?: string;

	/**
	 * @generated from field: string provider_account_id = 3;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: string provider_account_number = 4;
	 */
	providerAccountNumber?: string;
};

/**
 * Describes the message billing.v1.EntityAccount.
 * Use `create(EntityAccountSchema)` to create a new message.
 */
export const EntityAccountSchema: GenMessage<EntityAccount, { jsonType: EntityAccountJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 8);

/**
 * @generated from message billing.v1.PaymentMethod
 */
export type PaymentMethod = Message<"billing.v1.PaymentMethod"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string provider_account_id = 2;
	 */
	providerAccountId: string;

	/**
	 * @generated from field: billing.v1.PaymentMethodType type = 3;
	 */
	type: PaymentMethodType;

	/**
	 * @generated from field: string ach_account_name = 4;
	 */
	achAccountName: string;

	/**
	 * @generated from field: string ach_account_number_mask = 5;
	 */
	achAccountNumberMask: string;

	/**
	 * @generated from field: string ach_account_type = 6;
	 */
	achAccountType: string;

	/**
	 * @generated from field: string ach_bank_name = 7;
	 */
	achBankName: string;

	/**
	 * @generated from field: string ach_routing_number = 8;
	 */
	achRoutingNumber: string;

	/**
	 * @generated from field: bool active = 9;
	 */
	active: boolean;

	/**
	 * @generated from field: string credit_card_holder_name = 10;
	 */
	creditCardHolderName: string;

	/**
	 * @generated from field: string credit_card_number_mask = 11;
	 */
	creditCardNumberMask: string;

	/**
	 * @generated from field: string credit_card_type = 12;
	 */
	creditCardType: string;

	/**
	 * @generated from field: int32 credit_card_expiration_month = 13;
	 */
	creditCardExpirationMonth: number;

	/**
	 * @generated from field: int32 credit_card_expiration_year = 14;
	 */
	creditCardExpirationYear: number;

	/**
	 * @generated from field: string name = 15;
	 */
	name: string;

	/**
	 * @generated from field: string payment_method_status = 16;
	 */
	paymentMethodStatus: string;
};

/**
 * @generated from message billing.v1.PaymentMethod
 */
export type PaymentMethodJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string provider_account_id = 2;
	 */
	providerAccountId?: string;

	/**
	 * @generated from field: billing.v1.PaymentMethodType type = 3;
	 */
	type?: PaymentMethodTypeJson;

	/**
	 * @generated from field: string ach_account_name = 4;
	 */
	achAccountName?: string;

	/**
	 * @generated from field: string ach_account_number_mask = 5;
	 */
	achAccountNumberMask?: string;

	/**
	 * @generated from field: string ach_account_type = 6;
	 */
	achAccountType?: string;

	/**
	 * @generated from field: string ach_bank_name = 7;
	 */
	achBankName?: string;

	/**
	 * @generated from field: string ach_routing_number = 8;
	 */
	achRoutingNumber?: string;

	/**
	 * @generated from field: bool active = 9;
	 */
	active?: boolean;

	/**
	 * @generated from field: string credit_card_holder_name = 10;
	 */
	creditCardHolderName?: string;

	/**
	 * @generated from field: string credit_card_number_mask = 11;
	 */
	creditCardNumberMask?: string;

	/**
	 * @generated from field: string credit_card_type = 12;
	 */
	creditCardType?: string;

	/**
	 * @generated from field: int32 credit_card_expiration_month = 13;
	 */
	creditCardExpirationMonth?: number;

	/**
	 * @generated from field: int32 credit_card_expiration_year = 14;
	 */
	creditCardExpirationYear?: number;

	/**
	 * @generated from field: string name = 15;
	 */
	name?: string;

	/**
	 * @generated from field: string payment_method_status = 16;
	 */
	paymentMethodStatus?: string;
};

/**
 * Describes the message billing.v1.PaymentMethod.
 * Use `create(PaymentMethodSchema)` to create a new message.
 */
export const PaymentMethodSchema: GenMessage<PaymentMethod, { jsonType: PaymentMethodJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 9);

/**
 * @generated from message billing.v1.SubscriptionSnapshot
 */
export type SubscriptionSnapshot = Message<"billing.v1.SubscriptionSnapshot"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId: string;

	/**
	 * @generated from field: string provider_subscription_id = 3;
	 */
	providerSubscriptionId: string;

	/**
	 * @generated from field: string provider_subscription_number = 4;
	 */
	providerSubscriptionNumber: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus subscription_status = 5;
	 */
	subscriptionStatus: SubscriptionStatus;

	/**
	 * @generated from field: google.protobuf.Timestamp start_date = 6;
	 */
	startDate?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date = 7;
	 */
	endDate?: Timestamp;

	/**
	 * @generated from field: int32 version = 8;
	 */
	version: number;

	/**
	 * @generated from field: bool is_trial = 9;
	 */
	isTrial: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp;
};

/**
 * @generated from message billing.v1.SubscriptionSnapshot
 */
export type SubscriptionSnapshotJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string entity_account_id = 2;
	 */
	entityAccountId?: string;

	/**
	 * @generated from field: string provider_subscription_id = 3;
	 */
	providerSubscriptionId?: string;

	/**
	 * @generated from field: string provider_subscription_number = 4;
	 */
	providerSubscriptionNumber?: string;

	/**
	 * @generated from field: billing.v1.SubscriptionStatus subscription_status = 5;
	 */
	subscriptionStatus?: SubscriptionStatusJson;

	/**
	 * @generated from field: google.protobuf.Timestamp start_date = 6;
	 */
	startDate?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp end_date = 7;
	 */
	endDate?: TimestampJson;

	/**
	 * @generated from field: int32 version = 8;
	 */
	version?: number;

	/**
	 * @generated from field: bool is_trial = 9;
	 */
	isTrial?: boolean;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message billing.v1.SubscriptionSnapshot.
 * Use `create(SubscriptionSnapshotSchema)` to create a new message.
 */
export const SubscriptionSnapshotSchema: GenMessage<SubscriptionSnapshot, { jsonType: SubscriptionSnapshotJson }> = /*@__PURE__*/ messageDesc(file_billing_v1_billing, 10);

/**
 * @generated from enum billing.v1.FeatureType
 */
export enum FeatureType {
	/**
	 * @generated from enum value: FEATURE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: FEATURE_TYPE_FLOW_ID_CONTACTS = 1;
	 */
	FLOW_ID_CONTACTS = 1,

	/**
	 * @generated from enum value: FEATURE_TYPE_WORKSPACES = 2;
	 */
	WORKSPACES = 2,

	/**
	 * @generated from enum value: FEATURE_TYPE_CODES_CREATED = 3;
	 */
	CODES_CREATED = 3,

	/**
	 * @generated from enum value: FEATURE_TYPE_SHORT_URLS_CREATED = 4;
	 */
	SHORT_URLS_CREATED = 4,
}

/**
 * @generated from enum billing.v1.FeatureType
 */
export type FeatureTypeJson = "FEATURE_TYPE_UNSPECIFIED" | "FEATURE_TYPE_FLOW_ID_CONTACTS" | "FEATURE_TYPE_WORKSPACES" | "FEATURE_TYPE_CODES_CREATED" | "FEATURE_TYPE_SHORT_URLS_CREATED";

/**
 * Describes the enum billing.v1.FeatureType.
 */
export const FeatureTypeSchema: GenEnum<FeatureType, FeatureTypeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 0);

/**
 * @generated from enum billing.v1.AccountStatus
 */
export enum AccountStatus {
	/**
	 * @generated from enum value: ACCOUNT_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ACCOUNT_STATUS_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: ACCOUNT_STATUS_DRAFT = 2;
	 */
	DRAFT = 2,

	/**
	 * @generated from enum value: ACCOUNT_STATUS_CANCELLED = 3;
	 */
	CANCELLED = 3,
}

/**
 * @generated from enum billing.v1.AccountStatus
 */
export type AccountStatusJson = "ACCOUNT_STATUS_UNSPECIFIED" | "ACCOUNT_STATUS_ACTIVE" | "ACCOUNT_STATUS_DRAFT" | "ACCOUNT_STATUS_CANCELLED";

/**
 * Describes the enum billing.v1.AccountStatus.
 */
export const AccountStatusSchema: GenEnum<AccountStatus, AccountStatusJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 1);

/**
 * @generated from enum billing.v1.TermType
 */
export enum TermType {
	/**
	 * @generated from enum value: TERM_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: TERM_TYPE_TERMED = 1;
	 */
	TERMED = 1,

	/**
	 * @generated from enum value: TERM_TYPE_EVERGREEN = 2;
	 */
	EVERGREEN = 2,
}

/**
 * @generated from enum billing.v1.TermType
 */
export type TermTypeJson = "TERM_TYPE_UNSPECIFIED" | "TERM_TYPE_TERMED" | "TERM_TYPE_EVERGREEN";

/**
 * Describes the enum billing.v1.TermType.
 */
export const TermTypeSchema: GenEnum<TermType, TermTypeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 2);

/**
 * @generated from enum billing.v1.SubscriptionStatus
 */
export enum SubscriptionStatus {
	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_DRAFT = 1;
	 */
	DRAFT = 1,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_PENDING_ACTIVATION = 2;
	 */
	PENDING_ACTIVATION = 2,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_PENDING_ACCEPTANCE = 3;
	 */
	PENDING_ACCEPTANCE = 3,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 4;
	 */
	ACTIVE = 4,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_CANCELLED = 5;
	 */
	CANCELLED = 5,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_SUSPENDED = 6;
	 */
	SUSPENDED = 6,

	/**
	 * @generated from enum value: SUBSCRIPTION_STATUS_EXPIRED = 7;
	 */
	EXPIRED = 7,
}

/**
 * @generated from enum billing.v1.SubscriptionStatus
 */
export type SubscriptionStatusJson = "SUBSCRIPTION_STATUS_UNSPECIFIED" | "SUBSCRIPTION_STATUS_DRAFT" | "SUBSCRIPTION_STATUS_PENDING_ACTIVATION" | "SUBSCRIPTION_STATUS_PENDING_ACCEPTANCE" | "SUBSCRIPTION_STATUS_ACTIVE" | "SUBSCRIPTION_STATUS_CANCELLED" | "SUBSCRIPTION_STATUS_SUSPENDED" | "SUBSCRIPTION_STATUS_EXPIRED";

/**
 * Describes the enum billing.v1.SubscriptionStatus.
 */
export const SubscriptionStatusSchema: GenEnum<SubscriptionStatus, SubscriptionStatusJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 3);

/**
 * @generated from enum billing.v1.ChargeType
 */
export enum ChargeType {
	/**
	 * @generated from enum value: CHARGE_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CHARGE_TYPE_RECURRING = 1;
	 */
	RECURRING = 1,

	/**
	 * @generated from enum value: CHARGE_TYPE_USAGE = 2;
	 */
	USAGE = 2,

	/**
	 * @generated from enum value: CHARGE_TYPE_ONETIME = 3;
	 */
	ONETIME = 3,
}

/**
 * @generated from enum billing.v1.ChargeType
 */
export type ChargeTypeJson = "CHARGE_TYPE_UNSPECIFIED" | "CHARGE_TYPE_RECURRING" | "CHARGE_TYPE_USAGE" | "CHARGE_TYPE_ONETIME";

/**
 * Describes the enum billing.v1.ChargeType.
 */
export const ChargeTypeSchema: GenEnum<ChargeType, ChargeTypeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 4);

/**
 * @generated from enum billing.v1.ChargeModel
 */
export enum ChargeModel {
	/**
	 * @generated from enum value: CHARGE_MODEL_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CHARGE_MODEL_FLAT_FEE = 1;
	 */
	FLAT_FEE = 1,

	/**
	 * @generated from enum value: CHARGE_MODEL_TIERED = 2;
	 */
	TIERED = 2,

	/**
	 * @generated from enum value: CHARGE_MODEL_VOLUME = 3;
	 */
	VOLUME = 3,

	/**
	 * @generated from enum value: CHARGE_MODEL_PER_UNIT = 4;
	 */
	PER_UNIT = 4,

	/**
	 * @generated from enum value: CHARGE_MODEL_OVERAGE = 5;
	 */
	OVERAGE = 5,

	/**
	 * @generated from enum value: CHARGE_MODEL_TIERED_WITH_OVERAGE = 6;
	 */
	TIERED_WITH_OVERAGE = 6,

	/**
	 * @generated from enum value: CHARGE_MODEL_MULTI_ATTRIBUTE_PRICING = 7;
	 */
	MULTI_ATTRIBUTE_PRICING = 7,

	/**
	 * @generated from enum value: CHARGE_MODEL_PRERATED_PER_UNIT = 8;
	 */
	PRERATED_PER_UNIT = 8,

	/**
	 * @generated from enum value: CHARGE_MODEL_PRERATED_PRICING = 9;
	 */
	PRERATED_PRICING = 9,

	/**
	 * @generated from enum value: CHARGE_MODEL_HIGH_WATERMARK_VOLUME_PRICING = 10;
	 */
	HIGH_WATERMARK_VOLUME_PRICING = 10,

	/**
	 * @generated from enum value: CHARGE_MODEL_HIGH_WATERMARK_TIERED_PRICING = 11;
	 */
	HIGH_WATERMARK_TIERED_PRICING = 11,

	/**
	 * @generated from enum value: CHARGE_MODEL_DISCOUNT_FIXED_AMOUNT = 12;
	 */
	DISCOUNT_FIXED_AMOUNT = 12,

	/**
	 * @generated from enum value: CHARGE_MODEL_DISCOUNT_PERCENTAGE = 13;
	 */
	DISCOUNT_PERCENTAGE = 13,
}

/**
 * @generated from enum billing.v1.ChargeModel
 */
export type ChargeModelJson =
	| "CHARGE_MODEL_UNSPECIFIED"
	| "CHARGE_MODEL_FLAT_FEE"
	| "CHARGE_MODEL_TIERED"
	| "CHARGE_MODEL_VOLUME"
	| "CHARGE_MODEL_PER_UNIT"
	| "CHARGE_MODEL_OVERAGE"
	| "CHARGE_MODEL_TIERED_WITH_OVERAGE"
	| "CHARGE_MODEL_MULTI_ATTRIBUTE_PRICING"
	| "CHARGE_MODEL_PRERATED_PER_UNIT"
	| "CHARGE_MODEL_PRERATED_PRICING"
	| "CHARGE_MODEL_HIGH_WATERMARK_VOLUME_PRICING"
	| "CHARGE_MODEL_HIGH_WATERMARK_TIERED_PRICING"
	| "CHARGE_MODEL_DISCOUNT_FIXED_AMOUNT"
	| "CHARGE_MODEL_DISCOUNT_PERCENTAGE";

/**
 * Describes the enum billing.v1.ChargeModel.
 */
export const ChargeModelSchema: GenEnum<ChargeModel, ChargeModelJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 5);

/**
 * @generated from enum billing.v1.UsageRecordStatus
 */
export enum UsageRecordStatus {
	/**
	 * @generated from enum value: USAGE_RECORD_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: USAGE_RECORD_STATUS_PENDING = 1;
	 */
	PENDING = 1,

	/**
	 * @generated from enum value: USAGE_RECORD_STATUS_PROCESSED = 2;
	 */
	PROCESSED = 2,

	/**
	 * @generated from enum value: USAGE_RECORD_STATUS_IMPORTING = 3;
	 */
	IMPORTING = 3,
}

/**
 * @generated from enum billing.v1.UsageRecordStatus
 */
export type UsageRecordStatusJson = "USAGE_RECORD_STATUS_UNSPECIFIED" | "USAGE_RECORD_STATUS_PENDING" | "USAGE_RECORD_STATUS_PROCESSED" | "USAGE_RECORD_STATUS_IMPORTING";

/**
 * Describes the enum billing.v1.UsageRecordStatus.
 */
export const UsageRecordStatusSchema: GenEnum<UsageRecordStatus, UsageRecordStatusJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 6);

/**
 * @generated from enum billing.v1.EntityAccountType
 */
export enum EntityAccountType {
	/**
	 * @generated from enum value: ENTITY_ACCOUNT_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: ENTITY_ACCOUNT_TYPE_CORP = 1;
	 */
	CORP = 1,

	/**
	 * @generated from enum value: ENTITY_ACCOUNT_TYPE_ORG = 2;
	 */
	ORG = 2,

	/**
	 * @generated from enum value: ENTITY_ACCOUNT_TYPE_WORKSPACE = 3;
	 */
	WORKSPACE = 3,
}

/**
 * @generated from enum billing.v1.EntityAccountType
 */
export type EntityAccountTypeJson = "ENTITY_ACCOUNT_TYPE_UNSPECIFIED" | "ENTITY_ACCOUNT_TYPE_CORP" | "ENTITY_ACCOUNT_TYPE_ORG" | "ENTITY_ACCOUNT_TYPE_WORKSPACE";

/**
 * Describes the enum billing.v1.EntityAccountType.
 */
export const EntityAccountTypeSchema: GenEnum<EntityAccountType, EntityAccountTypeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 7);

/**
 * @generated from enum billing.v1.PaymentMethodType
 */
export enum PaymentMethodType {
	/**
	 * @generated from enum value: PAYMENT_METHOD_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PAYMENT_METHOD_TYPE_CREDIT_CARD = 1;
	 */
	CREDIT_CARD = 1,

	/**
	 * @generated from enum value: PAYMENT_METHOD_TYPE_ACH = 2;
	 */
	ACH = 2,
}

/**
 * @generated from enum billing.v1.PaymentMethodType
 */
export type PaymentMethodTypeJson = "PAYMENT_METHOD_TYPE_UNSPECIFIED" | "PAYMENT_METHOD_TYPE_CREDIT_CARD" | "PAYMENT_METHOD_TYPE_ACH";

/**
 * Describes the enum billing.v1.PaymentMethodType.
 */
export const PaymentMethodTypeSchema: GenEnum<PaymentMethodType, PaymentMethodTypeJson> = /*@__PURE__*/ enumDesc(file_billing_v1_billing, 8);
